const imageLink = 'https://static.tabia.health/assets/images'
const images = ['/1.jpg', '/2.jpg', '/3.jpg', '/4.jpg']

const useImageRandomPath = () => {
  const randomNumber = Math.floor(Math.random() * images.length)
  return `${imageLink + images[randomNumber]}`
}

export default useImageRandomPath
